import React, { Component } from 'react';

import Slider from 'components/Slider';

import platform1 from './images/platform1.jpg';
import platform2 from './images/platform2.jpg';
import platform3 from './images/platform3.jpg';

import './style.scss';

class Platform extends Component {
    render() {
        return (
            <div className="platform-root">
                <div className="site-main" data-animation="a-flyTopIn">
                    <div className="platform-des">
                        <p>Trade on the go with our mobile-driven platform, anytime, anywhere.</p>
                    </div>
                    {/* 小屏幕 slide */}
                    <Slider className="platform-slides">
                        <div className="slide slide1" />
                        <div className="slide slide2" />
                        <div className="slide slide3" />
                    </Slider>
                    {/* PC 正常展示 */}
                    <ul className="platform-list">
                        <li className="item" data-animation="a-flyRightIn">
                            <img src={platform1} title="platform" className="icon" alt="platform1" />
                        </li>
                        <li className="item delay200" data-animation="a-flyRightIn">
                            <img src={platform2} title="platform" className="icon" alt="platform2" />
                        </li>
                        <li className="item delay400" data-animation="a-flyRightIn">
                            <img src={platform3} title="platform" className="icon" alt="platform3" />
                        </li>
                    </ul>
                </div>
            </div>
        );
    }
}

export default Platform;
